// public/v3/src/lib/pain-assessment-entry.js — pure builder for
// PainAssessmentModal save handlers.
//
// Takes the modal's form state and produces two records to append in a
// single PUT:
//   1. assessmentRecord — structured entry for data.pain.assessments[]
//   2. activityLogEntry — entry for data.activityLog[] tagged with the
//      patient's billing.painProgram CPT so entryProgramFamily()
//      classifies it as pain.
//
// Pure functions only. CommonJS so Jest can read directly.

function staffNameForUser(user) {
  return String((user && (user.displayName || user.name || user.email)) || '').trim();
}

function formatPainAssessmentDesc(form) {
  const sev = form.severity ? ' (' + form.severity + ')' : '';
  const noteRaw = String(form.notes || '').trim();
  const note = noteRaw ? ' ' + noteRaw.slice(0, 160) : '';
  return form.scale + ' administered, score ' + form.score + sev + '.' + note;
}

function buildPainAssessmentEntry(patient, form, currentUser, tsArg) {
  const ts = tsArg != null ? tsArg : Date.now();
  const rand = Math.random().toString(36).slice(2, 6);
  const id = 'r' + ts + rand;
  const staff = staffNameForUser(currentUser);
  const painProgram = patient && patient.billing && patient.billing.painProgram;
  const credential = (currentUser && currentUser.credential) || '';

  const assessmentRecord = {
    scale: form.scale,
    date: form.date,
    score: form.score,
    severity: form.severity || '',
    notes: String(form.notes || '').trim(),
    recordedBy: staff || '',
    recordedByCredential: credential,
    ts,
  };

  const activityLogEntry = {
    id,
    pid: patient.id,
    type: 'Pain Assessment',
    duration: Number(form.timeSpent) || 5,
    ts,
    date: form.date,
    desc: formatPainAssessmentDesc(form),
    notes: String(form.notes || '').trim(),
    staff,
    staffUserId: (currentUser && currentUser.id) || '',
    credential,
    kind: 'pain-assessment',
    assessmentRef: {
      scale: form.scale,
      score: form.score,
      severity: form.severity || '',
      date: form.date,
    },
  };
  if (painProgram) activityLogEntry.program = painProgram;
  if (credential) {
    activityLogEntry.credentialSource = 'staff-list-id';
  }

  return { assessmentRecord, activityLogEntry };
}

module.exports = { buildPainAssessmentEntry, formatPainAssessmentDesc };
